<template>
  <search-layout>
    <template v-slot:contents>
      <field-input title="대출과목" cols="4">
        <v-select
          v-model="loanSubject"
          :items="loanSubjectList"
          item-text="text"
          item-value="value"
          placeholder="대출과목을 선택하세요"
          outlined hide-details dense
          background-color="white"
          @change="changeLoanSubject"
        />
      </field-input>
      <field-input title="종류" cols="4">
        <v-select
          v-model="loanSubjectType"
          :items="filterLoanSubjectTypeList"
          item-text="text"
          item-value="value"
          placeholder="종류를 선택하세요"
          outlined hide-details dense
          :background-color="selectLoanSubject ? 'white' : 'grey lighten-2'"
          :disabled="!selectLoanSubject"
          @change="changeLoanSubjectType"
        />
      </field-input>
      <field-input title="중개업소 유/무" cols="4">
        <v-select
          v-model="loanBrokerYn"
          :items="loanBrokerYnList"
          item-text="text"
          item-value="value"
          placeholder="중개업소 유/무를 선택하세요"
          outlined hide-details dense
          :background-color="selectLoanSubjectType ? 'white' : 'grey lighten-2'"
          :disabled="!selectLoanSubjectType"
        />
      </field-input>
      <field-input title="대출금액(원)" cols="4">
        <v-text-field
            v-model="loanAmount"
            class="amount-input"
            outlined hide-details dense
            :background-color="!disableLoanAmount ? 'white' : 'grey lighten-2'"
            @input="formatAmount"
            @keydown="preventComma"
            :disabled="disableLoanAmount"
        />
      </field-input>
      <field-input title="수수료금액(원)" cols="4">
        <v-text-field
            v-model="feeAmount"
            class="amount-input"
            outlined hide-details dense
            background-color="white" disabled
        />
      </field-input>
      <field-input cols="2">
        <v-btn class="button" outlined @click="calculation">계산</v-btn>
      </field-input>
    </template>
  </search-layout>
</template>
<script>
import SearchLayout from "@/common/layout/SearchLayout.vue";
import FieldInput from "@/common/components/input/FieldInput.vue";
import TableMixin from "@/mixin/TableMixin";

export default {
  name: "CommissionCalculationSearchBar",
  components: {FieldInput, SearchLayout},
  props: ["feeData"],
  mixins: [TableMixin],
  data() {
    return {
      loanSubject: "",
      loanSubjectList: [
        { text: "주택담보", value: "house"},
        { text: "유동화적격", value: "securitization"},
        { text: "부동산담보", value: "realestate"},
        { text: "전세자금", value: "jeonseFund"},
        { text: "자동차금융", value: "carfinance"},
        { text: "집단대출", value: "grploan"},
        { text: "신용대출", value: "crdtloan"}
      ],
      loanSubjectType: "",
      loanSubjectTypeList: [
        { text: "일반(아파트)", value: "gen", key: "house" },
        { text: "연립/빌라 등", value: "vil", key: "house" },
        { text: "장기고정금리", value: "lfixed", key: "securitization" },
        { text: "금리고정형", value: "fixed", key: "securitization" },
        { text: "주거용오피스텔", value: "resiofficetel", key: "realestate" },
        { text: "-", value: "-", key: "jeonseFund" },
        { text: "신차/택시", value: "newtaxi", key: "carfinance" },
        { text: "화물차", value: "truck", key: "carfinance" },
        { text: "중고차", value: "used", key: "carfinance" },
        { text: "집단 이주 잔금", value: "movebal", key: "grploan" },
        { text: "집단 전세 대출", value: "jeonse", key: "grploan" },
        { text: "이주비", value: "movecost", key: "grploan" },
        { text: "중도금(대면)", value: "interimface", key: "grploan" },
        { text: "중도금(비대면)", value: "interimremote", key: "grploan" },
        { text: "새희망홀씨", value: "newholssi", key: "crdtloan" }
      ],
      loanBrokerYn: "",
      loanBrokerYnList: [
        { text: "유", value: "Y"},
        { text: "무", value: "N"}
      ],
      loanAmount: 0,
      feeAmount: 0,
      disableLoanAmount: false
    }
  },
  computed: {
    selectLoanSubject() {
      return (this.loanSubject !== "") && ((this.loanSubject !== "jeonseFund"));
    },
    selectLoanSubjectType() {
      return (this.loanSubjectType !== "") && !(this.loanSubject === "grploan" || this.loanSubject === "crdtloan");
    },
    filterLoanSubjectTypeList() {
      let resultList = [];
      if (this.loanSubject === "") {
        return [];
      }
      resultList = this.loanSubjectTypeList.filter(item => item.key === this.loanSubject);
      return resultList;
    },
  },
  methods: {
    calculation() {
      this.feeAmount = 0;
      if (
          this.loanSubject === "" ||
          this.loanSubjectType === "" ||
          this.loanBrokerYn === "" ||
          this.loanAmount <= 0
    ) {
        this.showAlert({message: "계산 전 입력정보를 다시 한번 확인해주세요"});
        return false;
      }
      let findSubject = `${this.loanSubject}${this.capitalizedWord(this.loanSubjectType)}${this.loanBrokerYn}`;
      findSubject = findSubject.replaceAll("-", "");
      const findFeeData = this.feeData[findSubject];
      this.feeAmount = !this.disableLoanAmount
          ? this.inputComma(Math.round(Number(this.loanAmount.replaceAll(",", "")) * (findFeeData / 100)))
          : this.inputComma(Number(this.loanAmount) * findFeeData);
    },
    capitalizedWord(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
    changeLoanSubject(subject) {
      if (subject === "jeonseFund") {
        this.loanSubjectType = "-";
      }
      if (subject === "grploan" || subject === "crdtloan") {
        this.loanBrokerYn = "-";
      }
      this.loanAmount = 0;
      this.feeAmount = 0;
    },
    changeLoanSubjectType(subjectType) {
      if (
          subjectType === "movecost" ||
          subjectType === "interimface" ||
          subjectType === "interimremote"
      ) {
        this.disableLoanAmount = true;
        this.loanAmount = 1;
      } else {
        this.disableLoanAmount = false;
        this.loanAmount = 0;
      }
    },
    preventComma() {
      if (event.key === ",") {
        event.preventDefault();
      }
    },
    formatAmount() {
      let pureAmount = this.loanAmount.replace(/\D/g, '');
      this.loanAmount = pureAmount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
  }
}
</script>

<style scoped>
.amount-input >>> input {
  text-align: right;
}
</style>